module.exports = __webpack_public_path__ + "fonts/Rift-Medium.b0232087.ttf";